import styled from "styled-components";
export const MainDiv = styled.div`
margin:60px auto`;
export const Container = styled.div`
  width: 85%;
  background-color: whitesmoke;
  height: auto;
  font-family: Museo-sans 700, sans-serif;
  color: #4b4b4b;
  padding: 100px;
  box-sizing: border-box;
`;

export const CardsDiv = styled.div`
  /* width:70%; */
  display: flex;
  /* border:1px solid blue; */
  margin:70px auto;
  justify-content: space-around;
`;

export const ContentDiv = styled.div`
  width: 50%;
  /* border: 1px solid brown; */
  text-align: left;
`;

export const ContentH1 = styled.h2`
  font-size: 26px; ;
`;

export const ContentP = styled.p`
  line-height: 35px;
  font-size: 17px;
`;
export const ImgDiv = styled.div`
  width: 300px;
  height: 210px;
`;
export const Img = styled.img`
  width: 100%;
  height: 100%;
`;
